import { render, staticRenderFns } from "./drugCompanies.vue?vue&type=template&id=6507347e&scoped=true"
import script from "./drugCompanies.vue?vue&type=script&lang=js"
export * from "./drugCompanies.vue?vue&type=script&lang=js"
import style0 from "./drugCompanies.vue?vue&type=style&index=0&id=6507347e&prod&lang=css"
import style1 from "./drugCompanies.vue?vue&type=style&index=1&id=6507347e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6507347e",
  null
  
)

export default component.exports